import TopBar from '../components/molecules/TopBar';
import TopBarHomeButton from '../components/atoms/TopBarHomeButton';
import { useAppSelector } from 'src/store/hooks';
import MarkdownRenderer from 'src/components/molecules/MarkdownRenderer';


const QuickHelp = () => {
    const config = useAppSelector(state => state.globalState.config);

    return (
        <div className="content">
            <TopBar
                leftButtons={[<TopBarHomeButton />]}
                title={config?.homeMenuItems['quick_help']?.customMenuLabel || "Schnelle Hilfe"}
                icon="icon_info.svg"
            />
            <div className="info-page">
                {config?.quickHelpContent && (
                    <MarkdownRenderer content={config.quickHelpContent} />
                )}
            </div>
        </div>
    );
};
export default QuickHelp;